import { FC } from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";
import pluralize from "pluralize";

import theme from "theme";

const useStyles = makeStyles({
  offerCountContainer: {
    paddingTop: theme.spacing(1),
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
    },
  },
});

interface OfferCountProps {
  investorOfferCount: number;
  uniqueBidderCount: number;
}

const OfferCount: FC<OfferCountProps> = ({
  investorOfferCount,
  uniqueBidderCount,
}) => {
  const classes = useStyles();

  return (
    <Box className={classes.offerCountContainer}>
      <Typography
        style={{ fontWeight: theme.typography.fontWeightBold }}
      >{`${investorOfferCount} ${pluralize(
        "offer",
        investorOfferCount,
      )} made by ${uniqueBidderCount} ${pluralize(
        "investor",
        uniqueBidderCount,
      )}`}</Typography>
    </Box>
  );
};
export default OfferCount;
